// ==========================================================================
// Toast Component - Displays global notifications
// ==========================================================================

import { useToastStore } from '@/stores/toastStore';

export function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 left-4 right-4 z-[200] flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`p-4 rounded-xl shadow-lg flex items-start gap-3 animate-slide-down ${
            toast.type === 'error'
              ? 'bg-red-500 text-white'
              : toast.type === 'success'
                ? 'bg-green-500 text-white'
                : 'bg-gray-800 text-white'
          }`}
          onClick={() => removeToast(toast.id)}
        >
          <span className="text-lg flex-shrink-0">
            {toast.type === 'error' ? '⚠️' : toast.type === 'success' ? '✓' : 'ℹ️'}
          </span>
          <p className="text-sm font-medium flex-1">{toast.message}</p>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              removeToast(toast.id);
            }}
            className="text-white/70 hover:text-white text-lg leading-none"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
